import { z } from 'zod';

export const priceSchema = z.number()
  .positive('Price must be positive')
  .max(10000, 'Price exceeds maximum')
  .refine(
    (val) => Number(val.toFixed(2)) === val,
    'Price must have at most 2 decimal places'
  );

export const stagingPriceSchema = z.object({
  ingredientName: z.string().min(1).max(200),
  zipCode: z.string().regex(/^\d{5}$/, 'ZIP code must be 5 digits'),
  price: priceSchema,
}).strict();

export type StagingPriceInput = z.infer<typeof stagingPriceSchema>;

export type PriceSource = 'kroger' | 'usda' | 'bls' | 'manual';
export type PriceConfidence = 'live' | 'estimate' | 'unknown';

export interface PurchasableInfo {
  soldUnit: string;
  pkgLabel: string;
  pkgSize: number;
  standardUnit: string;
  packagesNeeded: number;
  recipeQtyInStandardUnit: number;
  leftoverQtyInStandardUnit: number;
  totalRecipeQty: string;
  leftoverQty: string;
  isSpecialty: boolean;
}

export interface PricedShoppingItem {
  ingredientId: string;
  ingredientName: string;
  qty: number;
  unit: string;
  estimatedPrice: number | null;
  priceSource: PriceSource | null;
  priceConfidence: PriceConfidence;
  purchasable?: PurchasableInfo | null;
}

export type BudgetStatus = 'under' | 'near' | 'over' | 'unknown';

export interface BudgetSummary {
  weeklyBudget: number | null;
  currentPlanCost: number;
  status: BudgetStatus;
  pricedItemCount: number;
  unpricedItemCount: number;
  truePurchaseCost: number;
  truePurchaseStatus: BudgetStatus;
  leftoverValue: number;
  estimatedMinimumWeeklyBudget: number | null;
}
